export const AVATAR_MAX_SIZE = 5;
